export default "__VITE_ASSET__DHR$ivxK__"